document.addEventListener("DOMContentLoaded", function () {
  // Mobile Menu
  let resizeTimeout = null;
  let previousScreenSize = null;

  // Global function to detect if mobile
  window.isMobile = function() {
    return window.innerWidth < 1024;
  };

  // Debounce function to prevent excessive calls
  let carouselInitTimeout = null;
  
  // Global function to initialize carousels based on open menu
  window.initializeMenuCarousels = function() {
    // Clear existing timeout
    if (carouselInitTimeout) {
      clearTimeout(carouselInitTimeout);
    }
    
    // Set new timeout to debounce calls
    carouselInitTimeout = setTimeout(() => {
      const isMobile = window.isMobile();
      const mobileMenu = document.getElementById('mobile-menu');
      const megaMenuWrapper = document.getElementById('mega-menu-wrapper');
      
      // Check if mobile menu is open
      const isMobileMenuOpen = mobileMenu && !mobileMenu.classList.contains('hidden');
      
      // Check if mega menu is open
      const isMegaMenuOpen = megaMenuWrapper && megaMenuWrapper.classList.contains('menu-open');
      
      if (isMobile && isMobileMenuOpen) {
        // Initialize mobile carousels
        initializeMobileCarousels();
      } else if (!isMobile && isMegaMenuOpen) {
        // Initialize mega menu carousels
        initializeMegaMenuCarousels();
      }
    }, 100); // 100ms debounce
  };

  function initializeMobileCarousels() {
    // Get all mobile carousel elements
    const mobileCarousels = document.querySelectorAll('[id^="menu-carousel-mobile-menu"]');
    
    mobileCarousels.forEach((carouselElement, index) => {
      const carouselId = carouselElement.id;
      
      // Check if carousel has slides
      const slides = carouselElement.querySelectorAll('.glide__slide');
      if (slides.length === 0) {
        return;
      }
      
      // Check if element is visible and in DOM
      if (!carouselElement.offsetParent && !carouselElement.getClientRects().length) {
        return;
      }
      
      // Check if carousel is already initialized and working
      if (window.mobileCarousels && window.mobileCarousels[carouselId]) {
        const existingCarousel = window.mobileCarousels[carouselId];
        // Check if the carousel is properly mounted and working
        if (existingCarousel && existingCarousel._o && existingCarousel.mount) {
          return; // Carousel is already working, don't reinitialize
        }
      }
      
      // Destroy existing carousel if it exists
      if (window.mobileCarousels && window.mobileCarousels[carouselId]) {
        try {
          window.mobileCarousels[carouselId].destroy();
        } catch (e) {
          console.warn('Error destroying existing carousel:', e);
        }
      }
      
      // Initialize new carousel
      if (typeof Glide !== 'undefined' && window.Glide) {
        try {
          setTimeout(() => {
          const element = document.getElementById(carouselId);
          console.log('element', element);
          if (!element) {
            console.warn('Carousel element not found:', carouselId);
            return;
          }

          const carousel = new Glide(element, {
            type: 'carousel',
            perView: 2.25,
            gap: 20,
            dragThreshold: 10,
            touchRatio: 1,
            touchAngle: 45,
            animationDuration: 400,
            rewind: false,
            autoplay: false,
            breakpoints: {
              1024: {
                perView: 4.25,
                gap: 24
              },
              768: { perView: 3.25, gap: 34},
              600: { perView: 2.25, gap: 34},
              400: { perView: 1.9, gap: 34}
              }
            }).mount();
          }, 2000);
          
          // Store carousel instance
          if (!window.mobileCarousels) {
            window.mobileCarousels = {};
          }
          window.mobileCarousels[carouselId] = carousel;
        } catch (e) {
          console.warn('Error initializing carousel:', carouselId, e);
        }
      } else {
        console.warn('Glide not available for carousel:', carouselId);
      }
    });
  }

  function initializeMegaMenuCarousels() {
    // Get the active link title
    const activeLinkTitle = window.activeMegaMenuLink;
    
    if (!activeLinkTitle) {
      return;
    }
    
    // Get the specific carousel for the active link
    // Use the same logic as Liquid's handleize filter
    const processedTitle = activeLinkTitle
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/-+/g, '-') // Replace multiple hyphens with single
      .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
    
    const carouselId = `menu-carousel-mega-menu-${processedTitle}`;

    const carouselElement = document.getElementById(carouselId);
    
    if (!carouselElement) {
      console.warn('Carousel element not found:', carouselId);
      return;
    }
    
    // Check if carousel has slides
    const slides = carouselElement.querySelectorAll('.glide__slide');
    if (slides.length === 0) {
      console.warn('No slides found in carousel:', carouselId);
      return;
    }
    
    // Check if element is in DOM (less restrictive for desktop)
    if (!carouselElement.parentNode) {
      console.warn('Carousel element not in DOM:', carouselId);
      return;
    }
    
    // Check if carousel is already initialized and working properly
    if (window.megaMenuCarousels && window.megaMenuCarousels[carouselId]) {
      const existingCarousel = window.megaMenuCarousels[carouselId];
      // Check if the carousel is properly mounted and working
      if (existingCarousel && existingCarousel._o && existingCarousel.mount && existingCarousel._o.type === 'carousel') {
        return; // Carousel is already working, don't reinitialize
      }
    }
    
    // Destroy existing carousel if it exists but is not working properly
    if (window.megaMenuCarousels && window.megaMenuCarousels[carouselId]) {
      try {
        window.megaMenuCarousels[carouselId].destroy();
      } catch (e) {
        console.warn('Error destroying existing carousel:', e);
      }
    }
    
        // Initialize new carousel
    if (typeof Glide !== 'undefined' && window.Glide) {
      try {
        // Add a small delay to ensure DOM is ready
        setTimeout(() => {
          const element = document.getElementById(carouselId);
          if (!element) {
            console.warn('Carousel element not found:', carouselId);
            return;
          }

          const carousel = new Glide(element, {
          type: 'carousel',
          perView: 2.5,
          gap: 20,
          dragThreshold: 10,
          touchRatio: 1,
          touchAngle: 45,
          animationDuration: 100,
          rewind: false,
          autoplay: false,
          breakpoints: {
            1440: {
              perView: 2.25,
              gap: 32
            },
            1130: {
              perView: 2,
              gap: 34
            },
            768: { perView: 2.15, gap: 34}
          }
        }).mount();
        
        // Store carousel instance
        if (!window.megaMenuCarousels) {
          window.megaMenuCarousels = {};
        }
        window.megaMenuCarousels[carouselId] = carousel;
      }, 100); // Increased delay for better reliability
      } catch (e) {
        console.warn('Error initializing carousel:', carouselId, e);
      }
    } else {
      console.warn('Glide not available for carousel:', carouselId);
    }
  }
  // Track previous window size for smart resize handling
  let previousWindowSize = null;
  
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    
    resizeTimeout = setTimeout(() => {
      // Handle responsive menu switching
      handleResponsiveMenuSwitch();
      
      const currentWindowSize = window.innerWidth;
      const mobileMenu = document.getElementById('mobile-menu');
      const megaMenuWrapper = document.getElementById('mega-menu-wrapper');
      const isMobileMenuOpen = mobileMenu && !mobileMenu.classList.contains('hidden');
      const isMegaMenuOpen = megaMenuWrapper && megaMenuWrapper.classList.contains('menu-open');
      
      // Only force reinitialization if there's a significant size change
      const sizeChanged = previousWindowSize === null || 
                         Math.abs(currentWindowSize - previousWindowSize) > 50; // 50px threshold
      
      if (sizeChanged && (isMobileMenuOpen || isMegaMenuOpen)) {
        
        // Clear existing carousels to force reinitialization
        if (isMobileMenuOpen && window.mobileCarousels) {
          Object.values(window.mobileCarousels).forEach(carousel => {
            if (carousel) {
              try {
                carousel.destroy();
              } catch (e) {
                console.warn('Error destroying mobile carousel:', e);
              }
            }
          });
          window.mobileCarousels = {};
        }
        
        if (isMegaMenuOpen && window.megaMenuCarousels) {
          Object.values(window.megaMenuCarousels).forEach(carousel => {
            if (carousel) {
              try {
                carousel.destroy();
              } catch (e) {
                console.warn('Error destroying mega menu carousel:', e);
              }
            }
          });
          window.megaMenuCarousels = {};
        }
        
        // Reinitialize carousels after a short delay
        setTimeout(() => {
          window.initializeMenuCarousels();
        }, 100);
      } else if (isMobileMenuOpen || isMegaMenuOpen) {
        // Just try to initialize without destroying (for minor size changes)
        window.initializeMenuCarousels();
      }
      
      previousWindowSize = currentWindowSize;
    }, 150);
  });

  // Initial check for responsive menu state
  handleResponsiveMenuSwitch();

  function handleResponsiveMenuSwitch() {
    const isDesktop = window.innerWidth >= 1024; // lg breakpoint
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileMenuContainer = document.getElementById('mobile-menu-container');
    const megaMenuWrapper = document.getElementById('mega-menu-wrapper');
    
    // Only handle switching if screen size actually changed
    if (previousScreenSize === null) {
      previousScreenSize = isDesktop ? 'desktop' : 'mobile';
      return;
    }
    
    const currentScreenSize = isDesktop ? 'desktop' : 'mobile';
    if (previousScreenSize === currentScreenSize) {
      return;
    }
    
    // If switching from mobile to desktop
    if (isDesktop && mobileMenu && !mobileMenu.classList.contains('hidden')) {
      // Close mobile menu
      mobileMenuContainer.classList.add('-translate-x-full');
      setTimeout(() => {
        mobileMenu.classList.add('hidden');
        
        // Clean up mobile carousels
        if (window.mobileCarousels) {
          Object.values(window.mobileCarousels).forEach(carousel => {
            if (carousel) carousel.destroy();
          });
          window.mobileCarousels = {};
        }
      }, 300);
    }
    
    // If switching from desktop to mobile and mega menu is open
    if (!isDesktop && megaMenuWrapper && megaMenuWrapper.classList.contains('menu-open')) {
      // Close mega menu by calling the global function
      if (window.hideAllPanels) {
        window.hideAllPanels();
      }
    }
    
    previousScreenSize = currentScreenSize;
  }

  window.openMobileMenu = function () {
    const mobileMenu = document.getElementById("mobile-menu");
    const mobileMenuContainer = document.getElementById(
      "mobile-menu-container"
    );

    if (mobileMenu && mobileMenuContainer) {
      mobileMenu.classList.remove("hidden");
      setTimeout(
        () => mobileMenuContainer.classList.remove("-translate-x-full"),
        10
      );
      
      // Initialize mobile carousels after menu is visible
      setTimeout(() => {
        window.initializeMenuCarousels();
      }, 100);
    }
  };

  // Initialize Vue app for cart functionality
  const { createApp } = Vue;
  createApp({
    delimiters: ["${", "}"],
    data() {
      return {
        cart: null,
      };
    },
    computed: {
      cartCount() {
        return store?.state?.cart?.item_count || 0;
      },
    },
    methods: {
      async updateCart() {
        try {
          const response = await fetch("/cart.js");
          this.cart = await response.json();
        } catch (error) {
          console.error("Error fetching cart:", error);
        }
      },
    },
    mounted() {
      this.updateCart();

      // Listen for cart updates
      document.addEventListener("cart:updated", () => {
        this.updateCart();
      });
    },
  }).mount("#navbar-cart");

  // Close handlers for drawers
  document.addEventListener("click", function (event) {
    // Close search on overlay click
    if (event.target.matches(".search-container")) {
      toggleSearch();
    }

    // Close cart on overlay click
    if (event.target.matches(".cart-drawer-overlay")) {
      toggleCart();
    }
  });

  // Handle escape key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      // Close search
      const searchContainer = document.querySelector(".search-container");
      if (searchContainer && !searchContainer.classList.contains("hidden")) {
        toggleSearch();
        return;
      }

      // Close cart
      const cartDrawer = document.querySelector(".cart-drawer");
      if (cartDrawer && !cartDrawer.classList.contains("hidden")) {
        toggleCart();
        return;
      }

      // Close mobile menu
      const mobileMenu = document.getElementById("mobile-menu");
      const mobileMenuContainer = document.getElementById(
        "mobile-menu-container"
      );
      if (mobileMenu && !mobileMenu.classList.contains("hidden")) {
        mobileMenuContainer.classList.add("-translate-x-full");
        setTimeout(() => mobileMenu.classList.add("hidden"), 300);
      }
    }
  });
});
